import { Cargos as c } from "../EditPanel/Cargos";
import { conLanding } from "../Models/Landing";

export default class Cargos extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}